import { render } from "./CardWrapper.vue?vue&type=template&id=1d399e94"
import script from "./CardWrapper.vue?vue&type=script&lang=js"
export * from "./CardWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CardWrapper.vue"]])

export default __exports__